import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWorkshop } from "../Common/WorkshopContext";

const WorkshopList = () => {
    const [workshops, setWorkshops] = useState([]);
    const { setWorkshopId } = useWorkshop();
    const navigate = useNavigate();

    useEffect(() => {
        // Fetch workshops the employee has access to (from localStorage or API)
        const employeeWorkshops = JSON.parse(localStorage.getItem('workshops'));
        if (employeeWorkshops) {
            setWorkshops(employeeWorkshops);
        } else {
            // Handle if no workshops found (e.g., show error or redirect to login)
            navigate('/login');
        }
    }, [navigate]);

    const handleSelectWorkshop = (workshopId) => {
        setWorkshopId(workshopId);
        navigate(`/workshops/dashboard/${workshopId}`);
    };

    return (
        <div className="container mx-auto p-4">
            <div className="max-w-4xl mx-auto bg-white shadow-md rounded-lg">
                <div className="p-6">
                    <h2 className="text-2xl font-semibold mb-4">Select a Workshop</h2>
                    <table className="min-w-full table-auto">
                        <thead>
                        <tr className="bg-gray-100">
                            <th className="px-4 py-2 text-left">Name</th>
                            <th className="px-4 py-2 text-left">Address</th>
                            <th className="px-4 py-2 text-left">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {workshops.map((workshop) => (
                            <tr key={workshop.id} className="border-t">
                                <td className="px-4 py-2">{workshop.name}</td>
                                <td className="px-4 py-2">{workshop.address}</td>
                                <td className="px-4 py-2">
                                    <button
                                        className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
                                        onClick={() => handleSelectWorkshop(workshop.id)}
                                    >
                                        Go to Dashboard
                                    </button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default WorkshopList;
